import { render } from "./Servis.vue?vue&type=template&id=22317b32&scoped=true"
import script from "./Servis.vue?vue&type=script&lang=js"
export * from "./Servis.vue?vue&type=script&lang=js"

import "./Servis.vue?vue&type=style&index=0&id=22317b32&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\Дентакорплюс\\dentakor\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22317b32"]])

export default __exports__